<template>
  <el-dialog
    :title="$t('shopCommunityManage.editShopCommunity')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form label-width="120px">
      <el-form-item :label="$t('shopCommunityManage.community')">
        <el-input :value="editShopCommunityInfo.communityName" disabled />
      </el-form-item>

      <el-form-item :label="$t('shopCommunityManage.deliveryType')">
        <el-select
          v-model="editShopCommunityInfo.deliveryType"
          :placeholder="$t('shopCommunityManage.selectDeliveryType')"
          style="width:100%"
          clearable
        >
          <el-option :label="$t('shopCommunityManage.followShopDefault')" value="" />
          <el-option :label="$t('shopCommunityManage.deliveryTypeStore')" value="STORE" />
          <el-option :label="$t('shopCommunityManage.deliveryTypeProperty')" value="PROPERTY" />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        <i class="el-icon-close"></i> {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editShopCommunity">
        <i class="el-icon-check"></i> {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateShopCommunity } from '@/api/goods/shopCommunityApi'

export default {
  name: 'EditShopCommunity',
  data() {
    return {
      dialogVisible: false,
      editShopCommunityInfo: {
        scId: '',
        shopId: '',
        communityId: '',
        communityName: '',
        startTime: '',
        endTime: '',
        deliveryType: ''
      }
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.editShopCommunityInfo = { ...data }
    },
    handleClose() {
      this.editShopCommunityInfo = {
        scId: '',
        shopId: '',
        communityId: '',
        communityName: '',
        startTime: '',
        endTime: '',
        deliveryType: ''
      }
    },
    async editShopCommunity() {
      // 后端 validate 要求 shopId/communityId/communityName/startTime/endTime/scId 全量非空，
      // 行数据原样透传（communityId/communityName/startTime/endTime 不变更）；
      // deliveryType 空值（跟随店铺默认）不 put 键，update 动态 set 跳过该字段保持 NULL（Task 9B 空值不 put 键先例）
      const payload = {
        scId: this.editShopCommunityInfo.scId,
        shopId: this.editShopCommunityInfo.shopId || getShopId(),
        communityId: this.editShopCommunityInfo.communityId,
        communityName: this.editShopCommunityInfo.communityName,
        startTime: this.editShopCommunityInfo.startTime,
        endTime: this.editShopCommunityInfo.endTime
      }
      if (this.editShopCommunityInfo.deliveryType) {
        payload.deliveryType = this.editShopCommunityInfo.deliveryType
      }

      try {
        await updateShopCommunity(payload)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('修改失败:', error)
        this.$message.error(error.message || this.$t('common.saveFailed'))
      }
    }
  }
}
</script>
